import * as React from "react";
import { forwardRef } from "react";
const SvgIconHeartEmpty = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "m12.857 21.853.007-.007 7.59-7.733h.001c1.906-1.943 2.342-5.691-.385-7.991-2.117-1.783-5.303-1.477-7.266.522l-.8.817-.801-.816c-1.955-1.99-5.14-2.306-7.265-.52-2.732 2.3-2.306 6.03-.386 7.988l7.59 7.733.007.007c.129.129.418.37.854.37.437 0 .726-.241.854-.37Z" }));
const ForwardRef = forwardRef(SvgIconHeartEmpty);
export { ForwardRef as ReactComponent };
